import React from "react";
import { isMobile } from "react-device-detect";

const RegressionWidgetFooter = () => {
  return (
    <>
      <div className="politics__infos">
        <span>
          *Η ΕΚΤΙΜΗΣΗ ΨΗΦΟΥ ΠΡΟΚΥΠΤΕΙ ΣΥΜΦΩΝΑ ΜΕ ΤΟ MOVING AVERAGE ΤΩΝ ΤΕΛΕΥΤΑΙΩΝ 10 ΔΗΜΟΣΚΟΠΗΣΕΩΝ
        </span>
      </div>
      {isMobile && (
        <div className="politics__footer">
          <a
            className="politics__button"
            href="https://www.news247.gr/pollitics"
            target="_self"
          >
            ΔΕΙΤΕ ΑΝΑΛΥΤΙΚΑ
          </a>
        </div>
      )}
    </>
  );
};

export default RegressionWidgetFooter;
